// extracted by mini-css-extract-plugin
module.exports = {"ModalTest":"_2KnRF","title":"_3KnF_","desc":"rMgkk","footer":"_1MP3K"};